module.exports = __webpack_public_path__ + "img/1567757038.20e89c2f.jpg";